<section class="tw-relative tw-py-[50px] lg:tw-py-[100px]">
    <svg
        class="tw-absolute tw-right-0 tw-hidden lg:tw-block"
        width="141"
        height="349"
        viewBox="0 0 141 349"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M346.19 201.678C331.19 296.41 242.016 361.01 147.015 345.967C52.0136 330.924 -12.8395 241.934 2.16112 147.202C17.1618 52.4696 106.336 -12.1309 201.337 2.91237C296.338 17.9556 361.191 106.946 346.19 201.678Z"
            fill="#FFD079"
            fill-opacity="0.65"
        />
        <path
            d="M256.038 187.679C248.895 232.794 206.53 263.576 161.415 256.432C116.301 249.288 85.5189 206.924 92.6628 161.809C99.8066 116.694 142.171 85.9122 187.286 93.0561C232.401 100.2 263.182 142.564 256.038 187.679Z"
            fill="white"
        />
    </svg>

    <div
        class="content tw-max-w-[1220px] tw-mx-auto tw-flex tw-gap-[90px] tw-overflow-hidden tw-py-0 tw-px-4"
    >
        <div class="flex-1 tw-relative tw-hidden lg:tw-block">
            <img
                data-sal="slide-up"
                data-sal-delay="300"
                data-sal-duration="1000"
                class="tw-h-[508px] tw-w-[466px]"
                src="/assets/images/home/asian-women.png"
                alt="Asian Women"
            />
            <svg
                data-sal="slide-up"
                data-sal-delay="500"
                data-sal-duration="1000"
                class="tw-absolute tw-top-[65px] tw-right-[-30px]"
                width="86"
                height="87"
                viewBox="0 0 86 87"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <ellipse
                    cx="43"
                    cy="43.5"
                    rx="43.5"
                    ry="43"
                    transform="rotate(-90 43 43.5)"
                    fill="#2280D6"
                    fill-opacity="0.65"
                />
            </svg>
        </div>
        <div class="flex-1 tw-w-full lg:tw-max-w-[576px] tw-relative">
            <h2
                data-sal="slide-up"
                data-sal-delay="300"
                data-sal-duration="1000"
                class="!tw-text-[22px] !tw-px-[28px] sm:!tw-p-0 sm:!tw-text-[30px] lg:!tw-text-[40px] !tw-font-bold !tw-text-[#0F3172] !tw-leading-[1.5]"
            >
                {{ "HOME.IMSME_TITLE" | translate }}
            </h2>
            <p
                data-sal="slide-up"
                data-sal-delay="500"
                data-sal-duration="1000"
                class="!tw-text-[14px] !tw-mb-[20px] !tw-px-[28px] sm:!tw-p-0"
            >
                {{ "HOME.IMSME_SUB_TITLE" | translate }}
            </p>

            <div class="tw-relative tw-block lg:tw-hidden tw-mb-4 tw-px-[28px]">
                <div class="tw-relative tw-w-fit">
                    <img
                        src="/assets/images/home/asian-women-mob.png"
                        alt="Asian Women"
                        class="tw-relative tw-z-[2] tw-h-[190px] sm:tw-h-auto"
                    />
                    <svg
                        class="tw-absolute tw-right-[-50px] tw-top-[50px]"
                        width="120"
                        height="120"
                        viewBox="0 0 120 120"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g opacity="0.8">
                            <ellipse
                                cx="60"
                                cy="60"
                                rx="60"
                                ry="60"
                                transform="rotate(-90 60 60)"
                                fill="#FFD079"
                                fill-opacity="0.65"
                            />
                            <ellipse
                                cx="60.2012"
                                cy="60.0374"
                                rx="28.4933"
                                ry="28.5743"
                                transform="rotate(-90 60.2012 60.0374)"
                                fill="white"
                            />
                        </g>
                    </svg>
                </div>

                <svg
                    class="tw-absolute tw-top-0 tw-right-[-15px]"
                    width="37"
                    height="52"
                    viewBox="0 0 37 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <ellipse
                        cx="25.5"
                        cy="26"
                        rx="26"
                        ry="25.5"
                        transform="rotate(-90 25.5 26)"
                        fill="#2280D6"
                        fill-opacity="0.65"
                    />
                </svg>
            </div>

            <ul
                data-sal="slide-up"
                data-sal-delay="500"
                data-sal-duration="1000"
                class="tw-flex tw-flex-col tw-gap-7 !tw-px-[28px] sm:!tw-p-0"
            >
                <li class="tw-flex tw-gap-[29px]">
                    <div
                        class="tw-min-w-[36px] tw-max-w-[36px] sm:tw-min-w-[48px] sm:tw-max-w-[48px]"
                    >
                        <img
                            class="tw-w-full"
                            src="/assets/images/home/clock.png"
                            alt=""
                        />
                    </div>
                    <div class="">
                        <h4
                            class="!tw-font-bold !tw-text-[18px] sm:!tw-text-[20px] !tw-mb-2"
                        >
                            {{
                                "HOME.COMPREHENSIVE_FINANCING_TITLE" | translate
                            }}
                        </h4>
                        <p class="!tw-text-[14px]">
                            {{
                                "HOME.COMPREHENSIVE_FINANCING_DESC" | translate
                            }}
                        </p>
                    </div>
                </li>
                <li class="tw-flex tw-gap-[29px]">
                    <div
                        class="tw-min-w-[36px] tw-max-w-[36px] sm:tw-min-w-[48px] sm:tw-max-w-[48px]"
                    >
                        <img
                            class="tw-w-full"
                            src="/assets/images/home/bill.png"
                            alt=""
                        />
                    </div>
                    <div class="">
                        <h4
                            class="!tw-font-bold !tw-text-[18px] sm:!tw-text-[20px] !tw-mb-2"
                        >
                            {{ "HOME.SEAMLESS_REFERRAL_TITLE" | translate }}
                        </h4>
                        <p class="!tw-text-[14px]">
                            {{ "HOME.SEAMLESS_REFERRAL_DESC" | translate }}
                        </p>
                    </div>
                </li>
                <li class="tw-flex tw-gap-[29px]">
                    <div
                        class="tw-min-w-[36px] tw-max-w-[36px] sm:tw-min-w-[48px] sm:tw-max-w-[48px]"
                    >
                        <img
                            class="tw-w-full"
                            src="/assets/images/home/mark.png"
                            alt=""
                        />
                    </div>
                    <div class="">
                        <h4
                            class="!tw-font-bold !tw-text-[18px] sm:!tw-text-[20px] !tw-mb-2"
                        >
                            {{ "HOME.INSTANT_PRODUCT_TITLE" | translate }}
                        </h4>
                        <p class="!tw-text-[14px]">
                            {{ "HOME.INSTANT_PRODUCT_DESC" | translate }}
                        </p>
                    </div>
                </li>
                <li class="tw-flex tw-gap-[29px]">
                    <div
                        class="tw-min-w-[36px] tw-max-w-[36px] sm:tw-min-w-[48px] sm:tw-max-w-[48px]"
                    ></div>
                    <div class="">
                        <a
                            ga-event-id="readmore_button_homepage_click"
                            ga-event-category="Homepage Button"
                            ga-event-label="Read More Text Click"
                            ga-track="track"
                            class="tw-text-[#4B6EEC] tw-text-[16px] tw-font-semibold"
                            [routerLink]="['/about-us']"
                        >
                            {{ "HOME.READ_MORE" | translate }} ></a
                        >
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>
